module.exports = __webpack_public_path__ + "static/img/jktlbj_cpjg_icon.png";